const textFieldModalEquipServiceGroup = {
  name: 'Nombre de la Sección'
};

export default textFieldModalEquipServiceGroup;
